import { CodeType } from 'components/common/types/AssetList.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getVisualUnitCodes } from 'modules/api/inventory';
import { FilterVisualUnitCodeAsyncProps } from './FilterVisualUnitCodeAsync.types';

const FilterVisualUnitCodeAsync: React.FC<FilterVisualUnitCodeAsyncProps> = ({ changeFilters, visualUnit }) => {
  const fetchVisualUnits: AsyncSelectLoadDataHandler<CodeType> = async (_, query) => {
    try {
      return await getVisualUnitCodes(cancelFunctions, query);
    } catch {
      return [];
    }
  };

  const onSelect: SelectHandler<CodeType> = (_, value: CodeType) => {
    changeFilters({ visualUnit: value });
  };

  return (
    <AsyncSelect
      dataTestId="visual-unit-code-input"
      name="visualUnit"
      textKey="code"
      loadData={fetchVisualUnits}
      onSelect={onSelect}
      placeholder="Select visual unit code"
      selectedValue={visualUnit}
    />
  );
};

export default FilterVisualUnitCodeAsync;
